import React, { useState, useEffect } from "react";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import {
  showMessage,
  getToken,
  ManageCategory,
} from "../../Functionalities/Functions";
import axios from "axios";
import FilterComponent from "../../CoreComponents/FilterComponent";
import LoadingComponent from "../../CoreComponents/LoadingComponent"
import {
  protocol,
  works_in_franchise,
  is_back_office,
} from "../../Functionalities/Config";
import { ManageInnerCategory } from './Logic'
import file from '../../Assets/images/bfile.png'

function Body(props) {
  //const [catData, setCatData] = useState([])
  const [data, setData] = useState({ id: "", name: "", data: [] });
  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");
  const [loading, setLoading] = useState(true)
  const [menuTab, setmenuTab] = useState(false)

  useEffect(() => {
    getData()
  }, [])

  const getData = () => {
    // showMessage("Loading categories", "info", "Loading", "bottom", "bottom-left", 0);
    let result = ManageInnerCategory("", "", "get", "");
    result
      .then((result) => {
        setData({
          ...data,
          data: result.data.results,
        });
        setLoading(false)
        setNext(result.data.next);
        setPrev(result.data.previous);
      })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-right",
          0
        );
        // void 0
      });
  };

  const handlePrev = () => {
    // alert("prev");
    var config = {
      method: "get",
      // url: prev,
      url: prev.replace("http:", protocol.replace('//', "")),
      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handleNext = () => {
    //alert("next")
    var config = {
      method: "get",
      // url: next,
      url: next.replace("http:", protocol.replace('//', "")),
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        // void 0
        setData({
          ...data,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  // const categories = props.categories
  // const length = categories.length
  // void 0
  // void 0
  return (
    <div class="content-body">
      {
        !loading ?
          <div class="container-fluid">
            <FilterComponent
              tab={"category"}
              handleNext={handleNext}
              handlePrev={handlePrev}
              next={next}
              prev={prev}

              addItemName={is_back_office && "Add Menu" }
              addItemPath={is_back_office && "/addMenu"}

              MenuFunction={
                (e, tabValue) => {
                  tabValue === "menu" ?
                    setmenuTab(true) : setmenuTab(false)
                }
              }
            />

            <div className="row">
              <div className="col-xl-12 col-xxl-12">
                <div className="card">
                  <div className="card-body most-favourite-items pb-0">
                    <div className="tab-content">
                      <div className="tab-pane fade show active" id="all-categories" >
                        <div className="row">
                          {data.data.map((category, index) => {
                            let data_image =
                              "https://static.thenounproject.com/png/2879926-200.png";
                            if (category.icon) {
                              data_image = category.icon.image;
                            }

                            return (
                              <div id={category.id} className="col-lg-4">
                                <div className="mb-4 align-items-center menu-card">
                                  <a href={is_back_office &&  `/menuID/${category.id}`} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                                    {" "}
                                    <img
                                      className="rounded mr-3 food-img"
                                      height="80"
                                      src={file}
                                      alt
                                    />
                                    <div><b style={{ fontSize: 12, position: 'absolute', bottom: 38, left: 47 }}>MENU</b></div>
                                  </a>

                                  <div className="media-body" >
                                    <h5 className="mb-sm-4 mb-3">
                                      <a
                                        className="text-black"
                                        href={is_back_office &&  `/menuID/${category.id}`}
                                      >
                                        <b >{category.name.charAt(0).toUpperCase() + category.name.slice(1)}</b>
                                        {works_in_franchise && <p>Products: {category.inner_category_items_count}</p>}
                                      </a>
                                    </h5>
                                  </div>
                                </div>
                                {menuTab && <div style={{
                                  backgroundColor: "green", display: "flex",
                                  align: "center", borderRadius: "10px", textAlign: "center", position: "absolute",
                                  bottom: "5px", left: "50%"
                                }}><span style={{ color: "white", padding: "2px" }}>Add Products</span>
                                </div>}
                              </div>
                            );
                          })}{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          : <LoadingComponent />
      }
    </div>
  );
}

function Categories() {
  const headers = "";
  // const categories = [
  //     { "id": 1, "name": "A", 'backgroundimage': "https://c.ndtvimg.com/2020-05/9iuj3h1g_indian-food_625x300_19_May_20.jpg" },
  //     { "id": 2, "name": "B", "backgroundimage": "https://images.unsplash.com/photo-1504674900247-0877df9cc836?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxleHBsb3JlLWZlZWR8M3x8fGVufDB8fHw%3D&w=1000&q=80" },
  //     { "id": 3, "name": "C", 'backgroundimage': "https://www.foodiesfeed.com/wp-content/uploads/2019/06/top-view-for-box-of-2-burgers-home-made.jpg" },
  //     { "id": 4, "name": "D", 'backgroundimage': "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRFKYmf6jHItCbfL8txsSCFfsCW254JYLEeNQ&usqp=CAU" }
  // ]
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={"Menu"} subHeading={"All Menu under foodoor"} />
        <NavBar />{" "}
        {/* <Body bo={boln} na={name} nu={num} ar={ary} ob={obj} ao={aryobj} /> */}
        <Body
        // categories={categories}
        />
        <Footer />
      </div>
    </div>
  );
}

export default Categories;
